import { BaSeBreakpointContext, BaSeButton, BaSeTheme } from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import logoArena from '../../../assets/logo-arena.png';
import logoUrbano from '../../../assets/logo-empretec.png';
import logoStartup from '../../../assets/logo-startup.png';
import {
  ContainerHeader,
  HeaderContent,
  HeaderLogoContainer,
  HeaderWrapper,
  LineHeader,
  LogoEmpretec,
  LogoSebrae,
} from './header-candidate-styled';

import { useInterviewController } from '../../../../../hooks/controllers/interview-controller';

const logos = {
  1: logoUrbano,
  2: logoStartup,
  3: logoArena,
};

export const LayoutHeaderCandidate = ({ moduleId }) => {
  const { logout, hasRoles } = Sebrae.useAuth();

  const path = window.location.pathname;

  const breakpointController = React.useContext(BaSeBreakpointContext);
  const [loading, setLoading] = React.useState(false);
  const [interview, setInterview] = React.useState();
  const { findInterviewByUserAuth } = useInterviewController();

  React.useEffect(() => {
    const findInterviewToLogout = async () => {
      setLoading(true);
      try {
        const response = await findInterviewByUserAuth();
        setInterview(response);
      } catch (error) {
        console.error('Erro ao carregar entrevista:', error);
      } finally {
        setLoading(false);
      }
    };

    findInterviewToLogout();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ContainerHeader>
      <HeaderContent>
        <HeaderWrapper>
          <HeaderLogoContainer>
            <LogoSebrae />
            <LogoEmpretec img={logoUrbano} />

            {/* {moduleId !== 1 && <LogoEmpretec img={logos[moduleId]} />} */}
            {breakpointController.inDesktop && moduleId && moduleId !== 1 && (
              <LogoEmpretec img={logos[moduleId]} />
            )}
          </HeaderLogoContainer>

          {!interview &&
            path.includes('candidato') &&
            hasRoles(['ADMINISTRADOR', 'GESTOR']) && (
              <div style={{ marginLeft: 'auto', zIndex: 9999 }}>
                <BaSeButton
                  onClick={() => logout()}
                  value="Logout"
                  color={BaSeTheme.colors.defaultColors.white}
                  type="tertiary"
                  isLoading={loading}
                />
              </div>
            )}
        </HeaderWrapper>
      </HeaderContent>
      <LineHeader />
    </ContainerHeader>
  );
};
